var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3, _g5, _g6, _g7, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatapilotSlider2 = function SvgDatapilotSlider2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 938 486"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "datapilot_slider2_svg__c",
    x1: 1,
    x2: 0,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee911c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datapilot_slider2_svg__a",
    x1: 0.039,
    x2: 1.039,
    y1: 0.502,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff603c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a50f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__d",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__e",
    x1: 0.012,
    x2: 1.01,
    y1: 0.394,
    y2: 0.394
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__f",
    x1: -4.606,
    x2: -3.447,
    y1: 1.434,
    y2: 1.434
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__g",
    x1: -0.722,
    x2: 0.304,
    y1: 0.901,
    y2: 0.901
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__h",
    x1: -1.321,
    x2: -0.252,
    y1: 0.802,
    y2: 0.802
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__i",
    x1: -0.309,
    x2: 0.725,
    y1: 0.637,
    y2: 0.637
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider2_svg__a",
    id: "datapilot_slider2_svg__j",
    x1: -1.682,
    x2: -0.682,
    y1: 1.243,
    y2: 1.243
  }), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider2_svg__b",
    width: 938,
    height: 361,
    x: 0,
    y: 125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 64h920v416H9z",
    "data-name": "Rectangle 133"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider2_svg__b)",
    transform: "translate(.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 343,
    fill: "#fcfcfc",
    "data-name": "Rectangle 138",
    rx: 10,
    transform: "translate(9 134)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.396 185h879v60h-879z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M28.396 244h879v1h-879z"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "3452_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(31.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3452_user-survey")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(208.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 23,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(322.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.312,
    y: 0
  }, "23")), /*#__PURE__*/React.createElement("text", {
    "data-name": 15,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(433.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.584,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    "data-name": 137,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(681.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 6 \\u2013 18"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Path 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.682 207h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M799.682 209a.754.754 0 0 0-.753.753v9.635c0 .415.338.753.753.753h9.635a.754.754 0 0 0 .753-.753v-9.635a.754.754 0 0 0-.753-.753zm0-2h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m808.012 210.994-4.731 4.818-2.151-2.19",
    "data-name": "Icon feather-check"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M811.876 222.055a2.3 2.3 0 0 1-.288-.379c-.285-.669-.9-.621-1.164-1.3-.533-.971-.657-.951-1.648-1.315-.7-.258-.9-.467-1.6-.744-.113-.045-.261-.182-.259-.275s.148-.229.262-.275a19 19 0 0 0 2.388-1.436c.938-.356 1.434-2.225 1.729-2.9a4 4 0 0 1 .389-.706 5 5 0 0 1 .469.706 6.3 6.3 0 0 0 1.606 2.295 7.3 7.3 0 0 0 2.679 2.03c.116.046.286.193.271.266a.5.5 0 0 1-.281.3c-.723.292-.786-.862-1.515-.583-.892.341-.678 1.834-1.335 2.642-.3.709-1.125.579-1.425 1.288a2.5 2.5 0 0 1-.281.389Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M811.874 222.027a1.7 1.7 0 0 1-.215-.284c-.213-.5-.424-1-.622-1.508a2.48 2.48 0 0 0-1.532-1.478 51 51 0 0 1-1.567-.6c-.085-.034-.2-.136-.194-.206s.111-.171.2-.206c.535-.214 1.076-.411 1.614-.615a2.43 2.43 0 0 0 1.464-1.416c.205-.512.2-1.031.426-1.537a3 3 0 0 1 .291-.529 4 4 0 0 1 .351.529c.223.514.433 1.033.643 1.552a2.42 2.42 0 0 0 1.451 1.4c.538.2 1.08.4 1.614.615.087.034.214.145.2.2a.37.37 0 0 1-.211.221c-.542.219-1.09.421-1.636.63a2.38 2.38 0 0 0-1.406 1.341c-.224.531-.435 1.067-.66 1.6a2 2 0 0 1-.211.291",
    "data-name": "Path 2741"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.397 208a.29.29 0 0 1 .271.152 1.92 1.92 0 0 0 1.434.853c.628.089 1.26.152 1.889.233.28.036.556.1.836.134a1.89 1.89 0 0 0 1.548-.439.17.17 0 0 1 .136-.033 1.4 1.4 0 0 1 .363.16c.318.231.625.475.933.719a1 1 0 0 1 .172.19.23.23 0 0 1 .008.261 1.77 1.77 0 0 0-.138 1.3 5.4 5.4 0 0 0 .224.706c.271.678.552 1.352.835 2.025a2.3 2.3 0 0 0 .581.855 1.6 1.6 0 0 0 .52.351.465.465 0 0 1 .346.52 3.4 3.4 0 0 1-.22 1.354.36.36 0 0 1-.354.255 1.48 1.48 0 0 0-.868.342 8.4 8.4 0 0 0-1.321 1.409q-.382.478-.766.954a2.6 2.6 0 0 0-.619 1.235 5 5 0 0 0-.007.533.2.2 0 0 1-.043.141 2.4 2.4 0 0 1-.423.293 3.8 3.8 0 0 1-1.32.414.2.2 0 0 1-.155-.055 1.98 1.98 0 0 0-1.444-.817c-.893-.139-1.784-.291-2.677-.429a2.13 2.13 0 0 0-1.226.142 1.4 1.4 0 0 0-.339.21.24.24 0 0 1-.272.05 1 1 0 0 1-.1-.04 4.2 4.2 0 0 1-1.178-.9.384.384 0 0 1-.082-.481 1.7 1.7 0 0 0 .068-1.3c-.168-.532-.37-1.054-.565-1.577a20 20 0 0 0-.437-1.108 2.17 2.17 0 0 0-1.3-1.252.2.2 0 0 1-.1-.115 1.05 1.05 0 0 1-.025-.567c.07-.347.133-.695.2-1.041a.316.316 0 0 1 .336-.3 2.2 2.2 0 0 0 1.518-.785q.821-.952 1.599-1.952a2.22 2.22 0 0 0 .5-1.307 2 2 0 0 0-.035-.414.18.18 0 0 1 .05-.194 1.3 1.3 0 0 1 .3-.22c.355-.148.718-.28 1.08-.412a2 2 0 0 1 .267-.053m7.048 7.483a5 5 0 0 0-9.994 0 5 5 0 0 0 9.994 0",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.299 212.065 1.735 1.483-.735.863q-1.712 2.007-3.429 4.011a1.8 1.8 0 0 1-.492.391c-.627.342-1.264.665-1.9.994a1 1 0 0 1-.128.06c-.2.067-.273.006-.242-.193a1 1 0 0 1 .05-.181c.234-.7.466-1.4.707-2.1a1 1 0 0 1 .181-.325q2.091-2.458 4.189-4.91a1 1 0 0 0 .06-.1Zm-3.98 5.358c-.127.378-.243.71-.348 1.045-.046.146.231.448.366.388.344-.155.674-.34 1.038-.528z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.898 211.89a2.75 2.75 0 0 1 1.991-.251 1.82 1.82 0 0 1 1.387 1.817 2.22 2.22 0 0 0 .685 1.765c.1.1.211.186.336.294l-1.056 1.235a3.27 3.27 0 0 0-3.028-1.026l1.473-2.938Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.47 215.123c.6.455 1.184.895 1.767 1.331q.349.261.7.512a1.16 1.16 0 0 1 .418 1.563 1.257 1.257 0 0 1-1.587.538 1.4 1.4 0 0 1-.411-.266c-.713-.7-1.417-1.4-2.122-2.1a.5.5 0 0 1-.048-.074l1.279-1.5Zm1.963 2.39a.617.617 0 1 0 0 1.234.64.64 0 0 0 .642-.618.63.63 0 0 0-.639-.616Z",
    "data-name": "Path 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.454 213.372c.184-.215.346-.417.522-.605a.427.427 0 0 1 .632-.047q.529.431 1.037.887a.424.424 0 0 1 .047.631c-.158.2-.333.395-.514.608Z",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.74 212.738c.553.264 1.049.493 1.536.742.046.024.069.18.04.247-.139.315-.3.621-.455.928-.1.2-.218.224-.383.059a2.8 2.8 0 0 1-.738-1.976",
    "data-name": "Path 22"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M887.004 220.8a1.894 1.894 0 0 0 2.018 1.725h8.073a1.894 1.894 0 0 0 2.015-1.725v-10.35h-12.106Zm2.018-8.626h8.073v8.626h-8.07Zm7.566-4.313-1.009-.861h-5.044l-1.009.863h-3.531v1.725h14.123v-1.725Z",
    "data-name": "Icon material-delete-outline"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.456 222.984h-8.309a2.06 2.06 0 0 1-2.1-2.014v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a.14.14 0 0 0 .144.139h8.308a.14.14 0 0 0 .144-.139v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a2.06 2.06 0 0 1-2.097 2.014",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.18 207a.96.96 0 0 1 .976.936v5.992l1.991-1.911a1 1 0 0 1 1.381 0 .9.9 0 0 1 0 1.324l-3.656 3.512a1.026 1.026 0 0 1-1.384 0l-3.646-3.5a.914.914 0 0 1 0-1.329 1.01 1.01 0 0 1 1.385 0l1.991 1.911v-5.999a.96.96 0 0 1 .962-.936",
    "data-name": "Path 4305"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.298 223.585h-8.622a2.137 2.137 0 0 1-2.177-2.09v-3.11a.97.97 0 0 1 .491-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a.147.147 0 0 0 .15.144h8.621a.147.147 0 0 0 .15-.144v-3.116a.97.97 0 0 1 .492-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a2.137 2.137 0 0 1-2.177 2.084",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.86 217.5a1 1 0 0 0 1.012-.972v-6.215l2.067 1.987a1.04 1.04 0 0 0 1.433 0 .937.937 0 0 0 0-1.373l-3.794-3.648a1.064 1.064 0 0 0-1.436 0l-3.783 3.634a.95.95 0 0 0 0 1.38 1.047 1.047 0 0 0 1.437 0l2.066-1.983v6.22a1 1 0 0 0 1 .972Z",
    "data-name": "Path 4305"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": 8,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(546.999 221.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 16,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(28.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Project")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(210.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Platform")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(314.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Responses")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(427.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Completes")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Sample Size",
    transform: "translate(680.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample Size")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(852.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Action")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Screened Out",
    transform: "translate(546.397 169)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Screened Out"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    "data-name": 10,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(108.624 458)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M138.427 449.201a.8.8 0 0 0-.567 1.37l5.814 5.814a.82.82 0 0 0 .567.235.8.8 0 0 0 .567-.235l5.806-5.807a.8.8 0 1 0-1.116-1.143l-5.246 5.266-5.257-5.257a.8.8 0 0 0-.567-.235Z",
    "data-name": "Path 2004"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    "data-name": "1 -10 of 20",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(745.397 458)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1 -10 of 20")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1915",
    opacity: 0.612
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#666",
    "data-name": "Rectangle 851",
    transform: "translate(874.9 437.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.497,
    height: 31.047,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.497,
    height: 30.047,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m893.177 453.471-3.587-3.256a.575.575 0 0 1 0-.87.73.73 0 0 1 .96 0l4.064 3.695a.576.576 0 0 1 .02.85l-4.081 3.72a.73.73 0 0 1-.96 0 .575.575 0 0 1 0-.87Z",
    "data-name": "Icon ionic-ios-arrow-back"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1916"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e1e1e1",
    "data-name": "Rectangle 851",
    transform: "translate(827.467 437.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.497,
    height: 31.047,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.497,
    height: 30.047,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m842.972 453.471 3.587-3.261a.575.575 0 0 0 0-.87.73.73 0 0 0-.96 0l-4.064 3.695a.576.576 0 0 0-.02.85l4.081 3.72a.73.73 0 0 0 .96 0 .575.575 0 0 0 0-.87Z",
    "data-name": "Icon ionic-ios-arrow-back"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Show Row",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(28.397 458)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Show Row")), /*#__PURE__*/React.createElement("g", {
    "data-name": "raw"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M28.397 245h879v60h-879z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M28.397 304h879v1h-879z",
    "data-name": "line"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "3452_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(30.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3452_user-survey")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Confirmit",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(208.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 50,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(322.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.048,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("text", {
    "data-name": 30,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(433.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.736,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    "data-name": 120,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(681.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "120")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 6 \\u2013 19"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Path 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.635 267h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M799.635 269a.754.754 0 0 0-.753.753v9.635c0 .415.338.753.753.753h9.635a.754.754 0 0 0 .753-.753v-9.635a.754.754 0 0 0-.753-.753zm0-2h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m807.965 270.994-4.731 4.818-2.151-2.19",
    "data-name": "Icon feather-check"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M811.829 282.055a2.3 2.3 0 0 1-.288-.379c-.285-.669-.9-.621-1.164-1.3-.533-.971-.657-.951-1.648-1.315-.7-.258-.9-.467-1.6-.744-.113-.045-.261-.182-.259-.275s.148-.229.262-.275a19 19 0 0 0 2.388-1.436c.938-.356 1.434-2.225 1.729-2.9a4 4 0 0 1 .389-.706 5 5 0 0 1 .469.706 6.3 6.3 0 0 0 1.606 2.295 7.3 7.3 0 0 0 2.679 2.03c.116.046.286.193.271.266a.5.5 0 0 1-.281.3c-.723.292-.786-.862-1.515-.583-.892.341-.678 1.834-1.335 2.642-.3.709-1.125.579-1.425 1.288a2.5 2.5 0 0 1-.281.389Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M811.827 282.027a1.7 1.7 0 0 1-.215-.284c-.213-.5-.424-1-.622-1.508a2.48 2.48 0 0 0-1.532-1.478 51 51 0 0 1-1.567-.6c-.085-.034-.2-.136-.194-.206s.111-.171.2-.206c.535-.214 1.076-.411 1.614-.615a2.43 2.43 0 0 0 1.464-1.416c.205-.512.2-1.031.426-1.537a3 3 0 0 1 .291-.529 4 4 0 0 1 .351.529c.223.514.433 1.033.643 1.552a2.42 2.42 0 0 0 1.451 1.4c.538.2 1.08.4 1.614.615.087.034.214.145.2.2a.37.37 0 0 1-.211.221c-.542.219-1.09.421-1.636.63a2.38 2.38 0 0 0-1.406 1.341c-.224.531-.435 1.067-.66 1.6a2 2 0 0 1-.211.291",
    "data-name": "Path 2741"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.364 268a.29.29 0 0 1 .271.152 1.92 1.92 0 0 0 1.434.853c.628.089 1.26.152 1.889.233.28.036.556.1.836.134a1.89 1.89 0 0 0 1.548-.439.17.17 0 0 1 .136-.033 1.4 1.4 0 0 1 .363.16c.318.231.625.475.933.719a1 1 0 0 1 .172.19.23.23 0 0 1 .008.261 1.77 1.77 0 0 0-.138 1.3 5.4 5.4 0 0 0 .224.706c.271.678.552 1.352.835 2.025a2.3 2.3 0 0 0 .581.855 1.6 1.6 0 0 0 .52.351.465.465 0 0 1 .346.52 3.4 3.4 0 0 1-.22 1.354.36.36 0 0 1-.354.255 1.48 1.48 0 0 0-.868.342 8.4 8.4 0 0 0-1.321 1.409q-.382.478-.766.954a2.6 2.6 0 0 0-.619 1.235 5 5 0 0 0-.007.533.2.2 0 0 1-.043.141 2.4 2.4 0 0 1-.423.293 3.8 3.8 0 0 1-1.32.414.2.2 0 0 1-.155-.055 1.98 1.98 0 0 0-1.444-.817c-.893-.139-1.784-.291-2.677-.429a2.13 2.13 0 0 0-1.226.142 1.4 1.4 0 0 0-.339.21.24.24 0 0 1-.272.05 1 1 0 0 1-.1-.04 4.2 4.2 0 0 1-1.178-.9.384.384 0 0 1-.082-.481 1.7 1.7 0 0 0 .068-1.3c-.168-.532-.37-1.054-.565-1.577a20 20 0 0 0-.437-1.108 2.17 2.17 0 0 0-1.3-1.252.2.2 0 0 1-.1-.115 1.05 1.05 0 0 1-.025-.567c.07-.347.133-.695.2-1.041a.316.316 0 0 1 .336-.3 2.2 2.2 0 0 0 1.518-.785q.821-.952 1.599-1.952a2.22 2.22 0 0 0 .5-1.307 2 2 0 0 0-.035-.414.18.18 0 0 1 .05-.194 1.3 1.3 0 0 1 .3-.22c.355-.148.718-.28 1.08-.412a2 2 0 0 1 .267-.053m7.048 7.483a5 5 0 0 0-9.994 0 5 5 0 0 0 9.994 0",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.266 272.065 1.735 1.483-.735.863q-1.712 2.007-3.429 4.011a1.8 1.8 0 0 1-.492.391c-.627.342-1.264.665-1.9.994a1 1 0 0 1-.128.06c-.2.067-.273.006-.242-.193a1 1 0 0 1 .05-.181c.234-.7.466-1.4.707-2.1a1 1 0 0 1 .181-.325q2.091-2.458 4.189-4.91a1 1 0 0 0 .06-.1Zm-3.98 5.358c-.127.378-.243.71-.348 1.045-.046.146.231.448.366.388.344-.155.674-.34 1.038-.528z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.865 271.89a2.75 2.75 0 0 1 1.991-.251 1.82 1.82 0 0 1 1.387 1.817 2.22 2.22 0 0 0 .685 1.765c.1.1.211.186.336.294l-1.056 1.235a3.27 3.27 0 0 0-3.028-1.026l1.473-2.938Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.437 275.123c.6.455 1.184.895 1.767 1.331q.349.261.7.512a1.16 1.16 0 0 1 .418 1.563 1.257 1.257 0 0 1-1.587.538 1.4 1.4 0 0 1-.411-.266c-.713-.7-1.417-1.4-2.122-2.1a.5.5 0 0 1-.048-.074l1.279-1.5Zm1.963 2.39a.617.617 0 1 0 0 1.234.64.64 0 0 0 .642-.618.63.63 0 0 0-.639-.616Z",
    "data-name": "Path 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.421 273.372c.184-.215.346-.417.522-.605a.427.427 0 0 1 .632-.047q.529.431 1.037.887a.424.424 0 0 1 .047.631c-.158.2-.333.395-.514.608Z",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.707 272.738c.553.264 1.049.493 1.536.742.046.024.069.18.04.247-.139.315-.3.621-.455.928-.1.2-.218.224-.383.059a2.8 2.8 0 0 1-.738-1.976",
    "data-name": "Path 22"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M887.004 280.8a1.894 1.894 0 0 0 2.018 1.725h8.073a1.894 1.894 0 0 0 2.015-1.725v-10.35h-12.106Zm2.018-8.626h8.073v8.626h-8.07Zm7.566-4.313-1.009-.861h-5.044l-1.009.863h-3.531v1.725h14.123v-1.725Z",
    "data-name": "Icon material-delete-outline"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.434 282.984h-8.309a2.06 2.06 0 0 1-2.1-2.014v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a.14.14 0 0 0 .144.139h8.308a.14.14 0 0 0 .144-.139v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a2.06 2.06 0 0 1-2.097 2.014",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.158 267a.96.96 0 0 1 .976.936v5.992l1.991-1.911a1 1 0 0 1 1.381 0 .9.9 0 0 1 0 1.324l-3.656 3.512a1.026 1.026 0 0 1-1.384 0l-3.646-3.5a.914.914 0 0 1 0-1.329 1.01 1.01 0 0 1 1.385 0l1.991 1.911v-5.999a.96.96 0 0 1 .962-.936",
    "data-name": "Path 4305"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.287 283.585h-8.622a2.137 2.137 0 0 1-2.177-2.09v-3.11a.97.97 0 0 1 .491-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a.147.147 0 0 0 .15.144h8.621a.147.147 0 0 0 .15-.144v-3.116a.97.97 0 0 1 .492-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a2.137 2.137 0 0 1-2.177 2.084",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.849 277.5a1 1 0 0 0 1.012-.972v-6.215l2.067 1.987a1.04 1.04 0 0 0 1.433 0 .937.937 0 0 0 0-1.373l-3.794-3.648a1.064 1.064 0 0 0-1.436 0l-3.783 3.634a.95.95 0 0 0 0 1.38 1.047 1.047 0 0 0 1.437 0l2.066-1.983v6.22a1 1 0 0 0 1 .972Z",
    "data-name": "Path 4305"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": 9,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(546.999 281.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "09"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "raw"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.397 305h879v60h-879z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M28.397 364h879v1h-879z",
    "data-name": "line"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "3452_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(30.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3452_user-survey")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Confirmit",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(208.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 23,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(322.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.312,
    y: 0
  }, "23")), /*#__PURE__*/React.createElement("text", {
    "data-name": 15,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(433.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.584,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    "data-name": 137,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(681.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 6 \\u2013 20"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Path 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.635 327h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M799.635 329a.754.754 0 0 0-.753.753v9.635c0 .415.338.753.753.753h9.635a.754.754 0 0 0 .753-.753v-9.635a.754.754 0 0 0-.753-.753zm0-2h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m807.965 330.994-4.731 4.818-2.151-2.19",
    "data-name": "Icon feather-check"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M811.829 342.055a2.3 2.3 0 0 1-.288-.379c-.285-.669-.9-.621-1.164-1.3-.533-.971-.657-.951-1.648-1.315-.7-.258-.9-.467-1.6-.744-.113-.045-.261-.182-.259-.275s.148-.229.262-.275a19 19 0 0 0 2.388-1.436c.938-.356 1.434-2.225 1.729-2.9a4 4 0 0 1 .389-.706 5 5 0 0 1 .469.706 6.3 6.3 0 0 0 1.606 2.295 7.3 7.3 0 0 0 2.679 2.03c.116.046.286.193.271.266a.5.5 0 0 1-.281.3c-.723.292-.786-.862-1.515-.583-.892.341-.678 1.834-1.335 2.642-.3.709-1.125.579-1.425 1.288a2.5 2.5 0 0 1-.281.389Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M811.827 342.027a1.7 1.7 0 0 1-.215-.284c-.213-.5-.424-1-.622-1.508a2.48 2.48 0 0 0-1.532-1.478 51 51 0 0 1-1.567-.6c-.085-.034-.2-.136-.194-.206s.111-.171.2-.206c.535-.214 1.076-.411 1.614-.615a2.43 2.43 0 0 0 1.464-1.416c.205-.512.2-1.031.426-1.537a3 3 0 0 1 .291-.529 4 4 0 0 1 .351.529c.223.514.433 1.033.643 1.552a2.42 2.42 0 0 0 1.451 1.4c.538.2 1.08.4 1.614.615.087.034.214.145.2.2a.37.37 0 0 1-.211.221c-.542.219-1.09.421-1.636.63a2.38 2.38 0 0 0-1.406 1.341c-.224.531-.435 1.067-.66 1.6a2 2 0 0 1-.211.291",
    "data-name": "Path 2741"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.364 328a.29.29 0 0 1 .271.152 1.92 1.92 0 0 0 1.434.853c.628.089 1.26.152 1.889.233.28.036.556.1.836.134a1.89 1.89 0 0 0 1.548-.439.17.17 0 0 1 .136-.033 1.4 1.4 0 0 1 .363.16c.318.231.625.475.933.719a1 1 0 0 1 .172.19.23.23 0 0 1 .008.261 1.77 1.77 0 0 0-.138 1.3 5.4 5.4 0 0 0 .224.706c.271.678.552 1.352.835 2.025a2.3 2.3 0 0 0 .581.855 1.6 1.6 0 0 0 .52.351.465.465 0 0 1 .346.52 3.4 3.4 0 0 1-.22 1.354.36.36 0 0 1-.354.255 1.48 1.48 0 0 0-.868.342 8.4 8.4 0 0 0-1.321 1.409q-.382.478-.766.954a2.6 2.6 0 0 0-.619 1.235 5 5 0 0 0-.007.533.2.2 0 0 1-.043.141 2.4 2.4 0 0 1-.423.293 3.8 3.8 0 0 1-1.32.414.2.2 0 0 1-.155-.055 1.98 1.98 0 0 0-1.444-.817c-.893-.139-1.784-.291-2.677-.429a2.13 2.13 0 0 0-1.226.142 1.4 1.4 0 0 0-.339.21.24.24 0 0 1-.272.05 1 1 0 0 1-.1-.04 4.2 4.2 0 0 1-1.178-.9.384.384 0 0 1-.082-.481 1.7 1.7 0 0 0 .068-1.3c-.168-.532-.37-1.054-.565-1.577a20 20 0 0 0-.437-1.108 2.17 2.17 0 0 0-1.3-1.252.2.2 0 0 1-.1-.115 1.05 1.05 0 0 1-.025-.567c.07-.347.133-.695.2-1.041a.316.316 0 0 1 .336-.3 2.2 2.2 0 0 0 1.518-.785q.821-.952 1.599-1.952a2.22 2.22 0 0 0 .5-1.307 2 2 0 0 0-.035-.414.18.18 0 0 1 .05-.194 1.3 1.3 0 0 1 .3-.22c.355-.148.718-.28 1.08-.412a2 2 0 0 1 .267-.053m7.048 7.483a5 5 0 0 0-9.994 0 5 5 0 0 0 9.994 0",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.266 332.065 1.735 1.483-.735.863q-1.712 2.007-3.429 4.011a1.8 1.8 0 0 1-.492.391c-.627.342-1.264.665-1.9.994a1 1 0 0 1-.128.06c-.2.067-.273.006-.242-.193a1 1 0 0 1 .05-.181c.234-.7.466-1.4.707-2.1a1 1 0 0 1 .181-.325q2.091-2.458 4.189-4.91a1 1 0 0 0 .06-.1Zm-3.98 5.358c-.127.378-.243.71-.348 1.045-.046.146.231.448.366.388.344-.155.674-.34 1.038-.528z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.865 331.89a2.75 2.75 0 0 1 1.991-.251 1.82 1.82 0 0 1 1.387 1.817 2.22 2.22 0 0 0 .685 1.765c.1.1.211.186.336.294l-1.056 1.235a3.27 3.27 0 0 0-3.028-1.026l1.473-2.938Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.437 335.123c.6.455 1.184.895 1.767 1.331q.349.261.7.512a1.16 1.16 0 0 1 .418 1.563 1.257 1.257 0 0 1-1.587.538 1.4 1.4 0 0 1-.411-.266c-.713-.7-1.417-1.4-2.122-2.1a.5.5 0 0 1-.048-.074l1.279-1.5Zm1.963 2.39a.617.617 0 1 0 0 1.234.64.64 0 0 0 .642-.618.63.63 0 0 0-.639-.616Z",
    "data-name": "Path 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.421 333.372c.184-.215.346-.417.522-.605a.427.427 0 0 1 .632-.047q.529.431 1.037.887a.424.424 0 0 1 .047.631c-.158.2-.333.395-.514.608Z",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.707 332.738c.553.264 1.049.493 1.536.742.046.024.069.18.04.247-.139.315-.3.621-.455.928-.1.2-.218.224-.383.059a2.8 2.8 0 0 1-.738-1.976",
    "data-name": "Path 22"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M887.004 340.8a1.894 1.894 0 0 0 2.018 1.725h8.073a1.894 1.894 0 0 0 2.015-1.725v-10.35h-12.106Zm2.018-8.626h8.073v8.626h-8.07Zm7.566-4.313-1.009-.861h-5.044l-1.009.863h-3.531v1.725h14.123v-1.725Z",
    "data-name": "Icon material-delete-outline"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.434 342.984h-8.309a2.06 2.06 0 0 1-2.1-2.014v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a.14.14 0 0 0 .144.139h8.308a.14.14 0 0 0 .144-.139v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a2.06 2.06 0 0 1-2.097 2.014",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.158 327a.96.96 0 0 1 .976.936v5.992l1.991-1.911a1 1 0 0 1 1.381 0 .9.9 0 0 1 0 1.324l-3.656 3.512a1.026 1.026 0 0 1-1.384 0l-3.646-3.5a.914.914 0 0 1 0-1.329 1.01 1.01 0 0 1 1.385 0l1.991 1.911v-5.999a.96.96 0 0 1 .962-.936",
    "data-name": "Path 4305"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.287 343.585h-8.622a2.137 2.137 0 0 1-2.177-2.09v-3.11a.97.97 0 0 1 .491-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a.147.147 0 0 0 .15.144h8.621a.147.147 0 0 0 .15-.144v-3.116a.97.97 0 0 1 .492-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a2.137 2.137 0 0 1-2.177 2.084",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.849 337.5a1 1 0 0 0 1.012-.972v-6.215l2.067 1.987a1.04 1.04 0 0 0 1.433 0 .937.937 0 0 0 0-1.373l-3.794-3.648a1.064 1.064 0 0 0-1.436 0l-3.783 3.634a.95.95 0 0 0 0 1.38 1.047 1.047 0 0 0 1.437 0l2.066-1.983v6.22a1 1 0 0 0 1 .972Z",
    "data-name": "Path 4305"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": 8,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(546.999 341.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "raw"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M28.398 365h879v60h-879z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M28.398 424h879v1h-879z",
    "data-name": "line"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "3452_user-survey",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(31 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3452_user-survey")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Confirmit",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(209 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirmit")), /*#__PURE__*/React.createElement("text", {
    "data-name": 50,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(323 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.048,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("text", {
    "data-name": 30,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(434 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.736,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    "data-name": 120,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(682 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "120")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 6 \\u2013 21"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Path 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.636 387h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M799.636 389a.754.754 0 0 0-.753.753v9.635c0 .415.338.753.753.753h9.635a.754.754 0 0 0 .753-.753v-9.635a.754.754 0 0 0-.753-.753zm0-2h9.635a2.753 2.753 0 0 1 2.753 2.753v9.635a2.753 2.753 0 0 1-2.753 2.753h-9.635a2.753 2.753 0 0 1-2.753-2.753v-9.635a2.753 2.753 0 0 1 2.753-2.753"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m807.966 390.994-4.731 4.818-2.151-2.19",
    "data-name": "Icon feather-check"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M811.83 402.055a2.3 2.3 0 0 1-.288-.379c-.285-.669-.9-.621-1.164-1.3-.533-.971-.657-.951-1.648-1.315-.7-.258-.9-.467-1.6-.744-.113-.045-.261-.182-.259-.275s.148-.229.262-.275a19 19 0 0 0 2.388-1.436c.938-.356 1.434-2.225 1.729-2.9a4 4 0 0 1 .389-.706 5 5 0 0 1 .469.706 6.3 6.3 0 0 0 1.606 2.295 7.3 7.3 0 0 0 2.679 2.03c.116.046.286.193.271.266a.5.5 0 0 1-.281.3c-.723.292-.786-.862-1.515-.583-.892.341-.678 1.834-1.335 2.642-.3.709-1.125.579-1.425 1.288a2.5 2.5 0 0 1-.281.389Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M811.828 402.027a1.7 1.7 0 0 1-.215-.284c-.213-.5-.424-1-.622-1.508a2.48 2.48 0 0 0-1.532-1.478 51 51 0 0 1-1.567-.6c-.085-.034-.2-.136-.194-.206s.111-.171.2-.206c.535-.214 1.076-.411 1.614-.615a2.43 2.43 0 0 0 1.464-1.416c.205-.512.2-1.031.426-1.537a3 3 0 0 1 .291-.529 4 4 0 0 1 .351.529c.223.514.433 1.033.643 1.552a2.42 2.42 0 0 0 1.451 1.4c.538.2 1.08.4 1.614.615.087.034.214.145.2.2a.37.37 0 0 1-.211.221c-.542.219-1.09.421-1.636.63a2.38 2.38 0 0 0-1.406 1.341c-.224.531-.435 1.067-.66 1.6a2 2 0 0 1-.211.291",
    "data-name": "Path 2741"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.365 388a.29.29 0 0 1 .271.152 1.92 1.92 0 0 0 1.434.853c.628.089 1.26.152 1.889.233.28.036.556.1.836.134a1.89 1.89 0 0 0 1.548-.439.17.17 0 0 1 .136-.033 1.4 1.4 0 0 1 .363.16c.318.231.625.475.933.719a1 1 0 0 1 .172.19.23.23 0 0 1 .008.261 1.77 1.77 0 0 0-.138 1.3 5.4 5.4 0 0 0 .224.706q.409 1.016.835 2.025a2.3 2.3 0 0 0 .581.855 1.6 1.6 0 0 0 .52.351.465.465 0 0 1 .346.52 3.4 3.4 0 0 1-.22 1.354.36.36 0 0 1-.354.255 1.48 1.48 0 0 0-.868.342 8.4 8.4 0 0 0-1.321 1.409q-.382.478-.766.954a2.6 2.6 0 0 0-.619 1.235 5 5 0 0 0-.007.533.2.2 0 0 1-.043.141 2.4 2.4 0 0 1-.423.293 3.8 3.8 0 0 1-1.32.414.2.2 0 0 1-.155-.055 1.98 1.98 0 0 0-1.444-.817c-.893-.139-1.784-.291-2.677-.429a2.13 2.13 0 0 0-1.226.142 1.4 1.4 0 0 0-.339.21.24.24 0 0 1-.272.05 1 1 0 0 1-.1-.04 4.2 4.2 0 0 1-1.178-.9.384.384 0 0 1-.082-.481 1.7 1.7 0 0 0 .068-1.3c-.168-.532-.37-1.054-.565-1.577a20 20 0 0 0-.437-1.108 2.17 2.17 0 0 0-1.3-1.252.2.2 0 0 1-.1-.115 1.05 1.05 0 0 1-.025-.567c.07-.347.133-.695.2-1.041a.316.316 0 0 1 .336-.3 2.2 2.2 0 0 0 1.518-.785q.821-.952 1.599-1.952a2.22 2.22 0 0 0 .5-1.307 2 2 0 0 0-.035-.414.18.18 0 0 1 .05-.194 1.3 1.3 0 0 1 .3-.22c.355-.148.718-.28 1.08-.412a2 2 0 0 1 .267-.053m7.048 7.483a5 5 0 0 0-9.994 0 5 5 0 0 0 9.994 0",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.267 392.065 1.735 1.483-.735.863q-1.712 2.007-3.429 4.011a1.8 1.8 0 0 1-.492.391c-.627.342-1.264.665-1.9.994a1 1 0 0 1-.128.06c-.2.067-.273.006-.242-.193a1 1 0 0 1 .05-.181c.234-.7.466-1.4.707-2.1a1 1 0 0 1 .181-.325q2.091-2.458 4.189-4.91a1 1 0 0 0 .06-.1Zm-3.98 5.358c-.127.378-.243.71-.348 1.045-.046.146.231.448.366.388.344-.155.674-.34 1.038-.528z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.866 391.89a2.75 2.75 0 0 1 1.991-.251 1.82 1.82 0 0 1 1.387 1.817 2.22 2.22 0 0 0 .685 1.765c.1.1.211.186.336.294l-1.056 1.235a3.27 3.27 0 0 0-3.028-1.026l1.473-2.938Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.438 395.123c.6.455 1.184.895 1.767 1.331q.349.261.7.512a1.16 1.16 0 0 1 .418 1.563 1.257 1.257 0 0 1-1.587.538 1.4 1.4 0 0 1-.411-.266c-.713-.7-1.417-1.4-2.122-2.1a.5.5 0 0 1-.048-.074l1.279-1.5Zm1.963 2.39a.617.617 0 1 0 0 1.234.64.64 0 0 0 .642-.618.63.63 0 0 0-.639-.616Z",
    "data-name": "Path 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.422 393.372c.184-.215.346-.417.522-.605a.427.427 0 0 1 .632-.047q.529.431 1.037.887a.424.424 0 0 1 .047.631c-.158.2-.333.395-.514.608Z",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.708 392.738c.553.264 1.049.493 1.536.742.046.024.069.18.04.247-.139.315-.3.621-.455.928-.1.2-.218.224-.383.059a2.8 2.8 0 0 1-.738-1.976",
    "data-name": "Path 22"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M887.005 400.8a1.894 1.894 0 0 0 2.018 1.725h8.073a1.894 1.894 0 0 0 2.015-1.725v-10.35h-12.106Zm2.018-8.626h8.073v8.626h-8.07Zm7.566-4.313L895.58 387h-5.044l-1.009.863h-3.531v1.725h14.123v-1.725Z",
    "data-name": "Icon material-delete-outline"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.435 402.984h-8.309a2.06 2.06 0 0 1-2.1-2.014v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a.14.14 0 0 0 .144.139h8.308a.14.14 0 0 0 .144-.139v-3a.93.93 0 0 1 .474-.852 1.01 1.01 0 0 1 1.007 0 .93.93 0 0 1 .474.852v3a2.06 2.06 0 0 1-2.097 2.014",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.159 387a.96.96 0 0 1 .976.936v5.992l1.991-1.911a1 1 0 0 1 1.381 0 .9.9 0 0 1 0 1.324l-3.656 3.512a1.026 1.026 0 0 1-1.384 0l-3.646-3.5a.914.914 0 0 1 0-1.329 1.01 1.01 0 0 1 1.385 0l1.991 1.911v-5.999a.96.96 0 0 1 .962-.936",
    "data-name": "Path 4305"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#484848",
    "data-name": "upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.288 403.585h-8.622a2.137 2.137 0 0 1-2.177-2.09v-3.11a.97.97 0 0 1 .491-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a.147.147 0 0 0 .15.144h8.621a.147.147 0 0 0 .15-.144v-3.116a.97.97 0 0 1 .492-.885 1.05 1.05 0 0 1 1.044 0 .97.97 0 0 1 .492.885v3.116a2.137 2.137 0 0 1-2.177 2.084",
    "data-name": "Path 4304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.85 397.5a1 1 0 0 0 1.012-.972v-6.215l2.067 1.987a1.04 1.04 0 0 0 1.433 0 .937.937 0 0 0 0-1.373l-3.794-3.648a1.064 1.064 0 0 0-1.436 0l-3.783 3.634a.95.95 0 0 0 0 1.38 1.047 1.047 0 0 0 1.437 0l2.066-1.983v6.22a1 1 0 0 0 1 .972Z",
    "data-name": "Path 4305"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": 9,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(547 401.185)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "09")))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(-975 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 44,
    fill: "url(#datapilot_slider2_svg__c)",
    "data-name": "Rectangle 24",
    rx: 6,
    transform: "translate(1747 103)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1964"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Add Project",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 17,
    fontWeight: 500,
    transform: "translate(1791.585 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Project")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M1770.93 115a9.93 9.93 0 1 0 9.93 9.93 9.94 9.94 0 0 0-9.93-9.93Zm0 19.239a9.309 9.309 0 1 1 9.309-9.309 9.32 9.32 0 0 1-9.309 9.309Zm6.566-9.309a.31.31 0 0 1-.311.311h-5.944v5.949a.312.312 0 0 1-.623 0v-5.951h-5.943a.312.312 0 1 1 0-.623h5.946v-5.941a.312.312 0 1 1 .623 0v5.946h5.946a.31.31 0 0 1 .306.309Z",
    "data-name": "Path 2196"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 396",
    transform: "translate(-16 -48)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 22,
    fontWeight: 500,
    transform: "translate(25 143)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects")), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 3,
    fill: "#f05a5c",
    "data-name": "Rectangle 141",
    rx: 1.5,
    transform: "translate(26 153)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 5 \\u2013 3"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e6e6e6",
    "data-name": "Rectangle 23",
    transform: "translate(352 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 44,
    stroke: "none",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 399,
    height: 43,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m384 107-5.194-5.2m2.879-6.954A9.842 9.842 0 1 1 371.842 85a9.84 9.84 0 0 1 9.842 9.842Z",
    "data-name": "Icon akar-search"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e8e8e8",
    d: "M394 79v34",
    "data-name": "Line 9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 0h920v64H9z",
    "data-name": "Rectangle 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e8e8e8",
    d: "M9 64h920",
    "data-name": "Line 1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 31",
    transform: "translate(307 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1934"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(60 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Icon material-dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21.111h8.889V10H15ZM15 30h8.889v-6.667H15Zm11.111 0H35V18.889h-8.889Zm0-20v6.667H35V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33 28v-7.111h-4.889V28zm-11.111 0v-2.667H17V28zm0-8.889V12H17v7.111zM33 14.667V12h-4.889v2.667zM35 30h-8.889V18.889H35zm-11.111 0H15v-6.667h8.889zm0-8.889H15V10h8.889zM35 16.667h-8.889V10H35z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 32",
    transform: "translate(490 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f2f2f2",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1935"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Projects",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(74 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects")), /*#__PURE__*/React.createElement("path", {
    d: "M49 27.778A2.21 2.21 0 0 1 46.8 30H29.2a2.21 2.21 0 0 1-2.2-2.222V12.222A2.21 2.21 0 0 1 29.2 10h5.5l2.2 3.333h9.9a2.21 2.21 0 0 1 2.2 2.223Z",
    "data-name": "Icon feather-folder"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f15b5b",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M136.5 41h-108",
    "data-name": "Line 11"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 33",
    transform: "translate(668 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1921"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Add Project",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(59.724 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Project")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Icon feather-folder-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.134 27.778A2.22 2.22 0 0 1 34.921 30H17.213A2.22 2.22 0 0 1 15 27.778V12.222A2.22 2.22 0 0 1 17.213 10h5.534l2.213 3.333h9.96a2.22 2.22 0 0 1 2.213 2.222Z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.067 18.889v6.667",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.747 22.222h6.64",
    "data-name": "Path 7"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 2 \\u2013 10"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    transform: "translate(-838 -19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "#e0e0e0",
    "data-name": "Rectangle 3",
    rx: 5,
    transform: "translate(1719 23)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(1743 51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.7,
    y: 0
  }, "AG"))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__a)",
    d: "M29.506 13.184A12.886 12.886 0 0 1 17.039 30.17 12.88 12.88 0 0 1 4.413 17.039a12.883 12.883 0 0 1 21-9.744 6.6 6.6 0 0 0 .854.567 20 20 0 0 1 1.351-1.606 17 17 0 0 1 1.461-1.577l-.064-.03.064.03.024-.011a17.293 17.293 0 1 0-18.86 28.422 17.3 17.3 0 0 0 23.1-22.215 23 23 0 0 0-.215-.512l-.03.01",
    "data-name": "Path 3839",
    transform: "rotate(-8 151.24 -679.572)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__d)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M13.52 25.452 0 11.131l11.769 6.494L36.127 0Z",
    "data-name": "Path 3840",
    transform: "rotate(-8 149.46 -703.978)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2659",
    transform: "rotate(-8 81.45 -884.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__e)",
    d: "M3.564.128a.567.567 0 1 1 .677.909L.9 3.535a.567.567 0 0 1-.678-.909Z",
    "data-name": "Path 3841",
    transform: "translate(1.017 10.371)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__f)",
    d: "M2.853.216a.567.567 0 1 1 .86.738L.994 4.122a.568.568 0 0 1-.86-.738Z",
    "data-name": "Path 3842",
    transform: "translate(2.958 12.462)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__g)",
    fillRule: "evenodd",
    d: "M3.669 3.636 0 2.932C3.706-.168 3.907-.026 6.612.013a18.6 18.6 0 0 0-2.943 3.625Z",
    "data-name": "Path 3843",
    transform: "translate(0 5.463)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__h)",
    fillRule: "evenodd",
    d: "m0 2.355.1 3.689C3.727 2.853 3.617 2.634 4.031 0A26.6 26.6 0 0 1 0 2.357Z",
    "data-name": "Path 3844",
    transform: "translate(8.406 12.269)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider2_svg__i)",
    fillRule: "evenodd",
    d: "M13.826 6.566c-1.455 2.427-7.259 6.934-10.37 7.793L0 10.329c1.281-2.906 6.7-7.947 9.322-9.015 6.9-2.77 8.3-1.224 4.505 5.253ZM11.573 3.94a2.343 2.343 0 0 1-.3 3.319 2.34 2.34 0 0 1-3.326-.213 2.386 2.386 0 1 1 3.626-3.106",
    "data-name": "Path 3845",
    transform: "translate(3.702)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.372,
    cy: 1.372,
    r: 1.372,
    fill: "url(#datapilot_slider2_svg__j)",
    "data-name": "Ellipse 15",
    transform: "translate(12.092 4.122)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 41.617q-1.127 0-1.127-1.192V20.261q0-1.192 1.127-1.192h5.508a7.32 7.32 0 0 1 6.249 2.738q2.062 2.738 2.062 8.5 0 5.8-2.062 8.552a7.3 7.3 0 0 1-6.249 2.754Zm3.157-3.608h2.384a3.13 3.13 0 0 0 3.012-1.82 13.9 13.9 0 0 0 .918-5.879 13.65 13.65 0 0 0-.918-5.83 3.13 3.13 0 0 0-3.012-1.8H14.15Zm17.459 3.833a4.39 4.39 0 0 1-3.431-1.341 5.3 5.3 0 0 1-1.208-3.688 5.8 5.8 0 0 1 .805-3.044 5.48 5.48 0 0 1 2.609-2.126 12.2 12.2 0 0 1 4.8-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.723-.6 7.9 7.9 0 0 0-2.094.258 13 13 0 0 0-1.546.515 2.7 2.7 0 0 1-.87.258q-.29 0-.467-.419a4 4 0 0 1-.258-.966 6.4 6.4 0 0 1-.081-.9q0-.419.821-.886a8.5 8.5 0 0 1 2.11-.789 10.9 10.9 0 0 1 2.641-.322q3.189 0 4.638 1.466a5.24 5.24 0 0 1 1.45 3.849v6.474a19 19 0 0 0 .161 2.963 8.4 8.4 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.886.306 9 9 0 0 1-1 .161q-.483.048-.709.048a.78.78 0 0 1-.757-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.482 1.345 4.35 4.35 0 0 1-2.414.628Zm1.288-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .982-1.031v-3.93a5 5 0 0 0-3.173.773 2.86 2.86 0 0 0-.918 2.319 2.7 2.7 0 0 0 .451 1.643 1.57 1.57 0 0 0 1.358.614Zm13.948 3.028a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4v-9.406h-.9q-.87 0-.87-1.385v-.483q0-1.385.87-1.385h.9l.483-3.157q.161-.934 1.417-.934h.773q1.45 0 1.45.934v3.157h1.643q.87 0 .87 1.385v.483q0 1.385-.87 1.385h-1.643v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.369.166Zm9.019 0a4.39 4.39 0 0 1-3.431-1.341 5.3 5.3 0 0 1-1.21-3.683 5.8 5.8 0 0 1 .805-3.044 5.48 5.48 0 0 1 2.609-2.126 12.2 12.2 0 0 1 4.8-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.723-.6 7.9 7.9 0 0 0-2.094.258 13 13 0 0 0-1.546.515 2.7 2.7 0 0 1-.87.258q-.29 0-.467-.419a4 4 0 0 1-.258-.966 6.4 6.4 0 0 1-.081-.9q0-.419.821-.886a8.5 8.5 0 0 1 2.11-.789 10.9 10.9 0 0 1 2.641-.322q3.189 0 4.638 1.466a5.24 5.24 0 0 1 1.45 3.849v6.474a19 19 0 0 0 .165 2.968 8.4 8.4 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.886.306 9 9 0 0 1-1 .161q-.483.048-.709.048a.78.78 0 0 1-.757-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.482 1.337 4.35 4.35 0 0 1-2.416.626Zm1.288-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .982-1.031v-3.93a5 5 0 0 0-3.173.773 2.86 2.86 0 0 0-.918 2.319 2.7 2.7 0 0 0 .451 1.643 1.57 1.57 0 0 0 1.358.614Zm11.725 2.867a2.73 2.73 0 0 1-1.337-.242.76.76 0 0 1-.4-.693V20.261q0-1.192 1.127-1.192h5.283q6.668 0 6.668 6.861 0 6.893-6.668 6.893h-2.127v7.924a.76.76 0 0 1-.4.693 2.73 2.73 0 0 1-1.337.242Zm2.546-12.465h2.126a2.22 2.22 0 0 0 1.917-.773 4.34 4.34 0 0 0 .564-2.512 4.27 4.27 0 0 0-.564-2.48 2.22 2.22 0 0 0-1.917-.773h-2.126Zm12.143 12.466a2.65 2.65 0 0 1-1.3-.242.76.76 0 0 1-.4-.693V25.64a.76.76 0 0 1 .4-.693 2.65 2.65 0 0 1 1.3-.242h.709a2.65 2.65 0 0 1 1.3.242.76.76 0 0 1 .4.693v15.107a.76.76 0 0 1-.4.693 2.65 2.65 0 0 1-1.3.242Zm.386-18.781a3.8 3.8 0 0 1-1.578-.242.75.75 0 0 1-.483-.693v-2.319a.73.73 0 0 1 .483-.66 3.8 3.8 0 0 1 1.578-.242 3.9 3.9 0 0 1 1.546.225.72.72 0 0 1 .483.676v2.319a.75.75 0 0 1-.483.693 3.7 3.7 0 0 1-1.546.243m9.277 18.94a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4V18.301a.76.76 0 0 1 .4-.693 2.65 2.65 0 0 1 1.3-.242h.709a2.65 2.65 0 0 1 1.3.242.76.76 0 0 1 .4.693v18.71a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.355.163Zm48.575 0a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4V28.02h-.9q-.87 0-.87-1.385v-.483q0-1.385.87-1.385h.9l.483-3.157q.161-.934 1.417-.934h.773q1.45 0 1.45.934v3.157h1.643q.87 0 .87 1.385v.483q0 1.385-.87 1.385h-1.643v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.369.167Z",
    "data-name": "Path 3846"
  })));
};
export default SvgDatapilotSlider2;